import React, { Component, type ReactNode } from 'react';
import { TdsMessage } from '@scania/tegel-react';

interface ErrorBoundaryProperties {
  readonly children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<ErrorBoundaryProperties, ErrorBoundaryState> {
  constructor(properties: ErrorBoundaryProperties) {
    super(properties);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    const content: ReactNode = hasError ? (
      <TdsMessage header="Something went wrong" variant="error" data-testid="error-boundary-message">
        Reload the page or try it again later
      </TdsMessage>
    ) : (
      children
    );

    return content;
  }
}

export default ErrorBoundary;
